// src/graphql/queries/downloadQueries.js
// Tender download bundles (ZIP exports with traitor-tracing watermarks).
// Company-scoped for customers; admins can look up any download by id.
// `url` is a fresh presigned link (15 min TTL) minted per poll while READY —
// never cache it; re-run the query for a new one.

export const getTenderDownload = () => `query GetTenderDownload($id: String!) {
    tenderDownload(id: $id) {
        id
        tenderId
        flavor
        includesBidlyzerDocs
        status
        fileCount
        missingCount
        bundleBytes
        url
        urlExpiresAt
        error
        createdAt
        completedAt
        expiresAt
    }
}`;
